import React, { Component } from "react";
import { Card, Container, Button, InputGroup } from "react-bootstrap";
import moment from "moment";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import CoreService from "../../../../../services/CoreService";
import IdentityService from "../../../../../services/IdentityService";


import QuarantineGrid from "./QuarantineGrid.jsx";
import ModalQuarantineDispositionDialog from "./ModalQuarantineDispositionDialog.jsx";
import { MsaReceiptStatusType } from "../../../../../models/MsaReceiptStatusType";


const dispositionReasons = [
  {"value": "Choose Reason for Disposition", "label": "Choose Reason for Disposition", "dispType": ""},
  {"value": "REINSPECT", "label": "Reinspect", "dispType": "autoreceipt"},
  {"value": "REPACK", "label": "Repack", "dispType": "endreceipt"},
  {"value": "RETURNTOGROWER", "label": "Return to Grower", "dispType": "endreceipt"},
  {"value": "DONATE", "label": "Donate", "dispType": "endreceipt"},
  {"value": "DUMP", "label": "Dump", "dispType": "endreceipt"}
];


export default class QuarantinePanel extends Component {
  constructor(props) {
    super(props);

    this.coreService = new CoreService();

    this.state = {
      data: null,
      selectedRow: null,
      isLoadingGrid: false,
    };

    this.onDispositionRequest = this.onDispositionRequest.bind(this);
    this.onDispositionPostRequest = this.onDispositionPostRequest.bind(this);
    this.onDispositionCancelRequest = this.onDispositionCancelRequest.bind(this);

    this.refreshData = this.refreshData.bind(this);
    this.onRowSelectChange = this.onRowSelectChange.bind(this);
  }

  async componentDidMount() {
    await this.refreshData();
  }

  async refreshData() {
    this.setState({ isLoadingGrid: true });
    var remoteDataResult = await this.coreService.fetchQuarantineReceipts(this.props.userSession.gcid, this.props.userSession.currentLocationId, moment().format(), this.props.userSession.token);
    this.setState({
      data: remoteDataResult.dataResult,
      selectedRow: null, // reset
      isLoadingGrid: false,
      showDispositionDialog: false
    });
  }

  onRowSelectChange(newSelectedRow) {
    this.setState({ selectedRow: newSelectedRow });
  }

  onDispositionRequest(ev) {
    // get the reason from the dialog
    this.setState({
      showDispositionDialog: true
    });
  }

  async onDispositionPostRequest(dispositionReason) {
    this.setState({ showDispositionDialog: false });
    if (!dispositionReason || dispositionReason === "Choose Reason for Disposition") {
      alert("Choose a Reason!");
      return;
    }
    console.log("Disposition Reason: " + dispositionReason);
    var dispositionResult = {"value": "", "label": "", "dispType": ""};
    for(var i=0; i<dispositionReasons.length; i++){
      if (dispositionReasons[i].value === dispositionReason){
        dispositionResult = dispositionReasons[i];
      }
    }
    if (dispositionResult.value === ""){
      alert("Problem finding disposition result.");
      return;
    }

    var selectedQuarantine = this.state.selectedRow;
    console.log("SelectedQuarantine Record: ");
    console.log(selectedQuarantine);

    if (dispositionResult.dispType === "autoreceipt")
    {
      // we want to autogenerate a receipt and post it
      var newPallet = selectedQuarantine.sourcePallet;
      newPallet.glassChainId = newPallet.glasschainId.replace('000-', '');
      newPallet.isDisposed = false;
      newPallet.disposition.grade = "";
      newPallet.disposition.score = "";
      newPallet.disposition.isQuarantined = false;
      newPallet.disposition.quarantineReason = "";
      var newLine = selectedQuarantine.sourceLine;
      newLine.lineId = IdentityService.makeUuid();
      newLine.tagLineQty = newPallet.unitQty;
      newLine.pallets = [];
      newLine.pallets.push(newPallet);
      newLine.tagLineQty = newPallet.unitQty;
      var newReceipt = selectedQuarantine.sourceReceipt;
      newReceipt.lines = [];
      newReceipt.lines.push(newLine);
      newReceipt.transactionId = IdentityService.makeUuid();
      newReceipt.tagId = ""; // will get regenerated upon post by core service
      newReceipt.receiveDateTime = moment().format();
      newReceipt.receiver = this.props.userSession.uid;
      newReceipt.receiverComment = "Autogen from quarantined pallet";
      newReceipt.status.tagId = "";
      newReceipt.status.lastStatus = newReceipt.status.flowStatus;
      newReceipt.status.lastStatusReason = newReceipt.status.flowStatusReason;
      newReceipt.status.flowStatus = MsaReceiptStatusType.TOMRA; // "AWAIT-QA";
      newReceipt.status.flowStatusReason = "Autogen from quarantined receipt";
      newReceipt.status.lastUpdated = moment().format();
      newReceipt.status.lastUpdatedBy = this.props.userSession.uid;

      console.log("New Receipt: ");
      console.log(newReceipt);

      var postReceiptDispositionResult = await this.coreService.postReceipt(this.props.userSession.gcid, newReceipt, "", this.props.userSession.token);
    }
    // FOR NOW we are just going to remove the quarantine record. Later, we should set a status or move to an 
    // archive.
    var closeQuarantineResult = await this.coreService.closeQuarantine(this.props.userSession.gcid, selectedQuarantine.quarantineId, this.props.userSession.token);
    //await this.httpClient.closeQuarantine(this.props.userSessionInfo.gcid, selectedQuarantine.quarantineId, this.props.userSessionInfo.token);
    await this.refreshData();
    this.setState({ showDispositionDialog: false });
  }

  onDispositionCancelRequest() {
    this.setState({ showDispositionDialog: false });
  }



  render() {
    const loadingGridIcon = this.state.isLoadingGrid ? (
      <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
    ) : (
      ""
    );

    return (
      <div>
        <ModalQuarantineDispositionDialog
          show={this.state.showDispositionDialog}
          dispositionReasonList={dispositionReasons}
          onDispositionPostRequest={this.onDispositionPostRequest}
          onDispositionCancelRequest={this.onDispositionCancelRequest}
        />

        <h3>Open Quarantined Pallets</h3>
        <span>
          <Card>
          <Card.Header style={{ display: "-webkit-inline-flex", maxHeight: "50px" }}>
            <span style={{ minWidth: "max-content", paddingTop: "0" }}>
            <p data-tip="Dispose Pallet">
                  <Button
                    size="sm"
                    variant="outline-info" 
                    onClick= {ev => this.onDispositionRequest(ev)}  
                  >
                    <FontAwesomeIcon icon={faPlusCircle} />
                        &nbsp;Dispose Pallet
                  </Button>
                </p>
            </span>
            <Container fluid style={{ paddingTop: "0" }}>
              <InputGroup size="sm" className="receipt-line-buttons">

              </InputGroup>
            <span style={{ float: "right", paddingLeft: "20px", paddingRight: "20px" }}>{loadingGridIcon}</span>
            </Container>
          </Card.Header>
          <Card.Body style={{padding: "0"}}>
            <div style={{ width: "100%", height: "100%" }}>
              <Container fluid>
              <QuarantineGrid
                rowData={this.state.data}
                onRowSelectChange={this.onRowSelectChange}
              />
              </Container>
            </div>
          </Card.Body>
        </Card>
      </span>

      </div>
    );
  }
}
